import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { IMap } from '@nimbus-library/features/shared/models/interfaces';
import { IPageMetadata } from '@nimbus-library/features/menu/models/menu-structure.model';
import { ObjectUtils } from '@nimbus-library/features/shared/utils/object.utils';

export abstract class ITitleProviderService {
  protected abstract titles: IMap<IPageMetadata>;

  public navigationEvent(activatedRoute: ActivatedRouteSnapshot, urlAfterRedirects: string): Observable<string> {
    const data = ObjectUtils.getLastChild(activatedRoute.root).data;
    let urlKey = data && data.metadataKey;

    if (!urlKey) {
      urlKey = urlAfterRedirects;

      if (urlKey.indexOf('?') !== -1) {
        urlKey = urlKey.substring(0, urlKey.indexOf('?'));
      }
    }

    return this.getTitle(urlKey);
  }

  public getTitle(urlKey: string): Observable<string> {
    const pageMetadata = this.titles[urlKey] || this.titles['*'];

    return pageMetadata.title$ ? this.resolve$(pageMetadata) : this.resolve(pageMetadata);
  }

  public resolve(pageMetadata: IPageMetadata) {
    return of(typeof pageMetadata.title === 'function' ? pageMetadata.title() : pageMetadata.title);
  }

  public resolve$(pageMetadata: IPageMetadata) {
    return typeof pageMetadata.title$ === 'function' ? pageMetadata.title$() : (pageMetadata.title$ as Observable<string>);
  }
}
